import React from "react";
import SummarizeIcon from '@mui/icons-material/Summarize';
import StarIcon from '@mui/icons-material/Star';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import GroupsIcon from '@mui/icons-material/Groups';


const PendingAccounts = React.lazy(() => import("../pages/Authenticated/Admin/pages/PendingAccounts"));
const RejectedAccounts = React.lazy(() => import("../pages/Authenticated/Admin/pages/RejectedAccounts"));
const SearchTransaction = React.lazy(() => import("../pages/Authenticated/Reports/SearchTransaction"));
const TopUpReport = React.lazy(() => import("../pages/Authenticated/Reports/TopUpReport"));


const CONFIG = {

    "APP_TITLE": "Pisape ",
    "APP_ID": 15,
    "APPBARLOGO": "https://imwlassets.s3.amazonaws.com/Pisape/Logo_PISAPE-removebg.png",
    "FAVICON": "https://imwlassets.s3.amazonaws.com/Pisape/Logo_PISAPE_FavIcon.png",
    "APPBUILD": 11600,
    "LOGO": "https://imwlassets.s3.amazonaws.com/Pisape/Logo_PISAPE-removebg.png",
    "NAVBAR_LOGO": "https://imwlassets.s3.amazonaws.com/Pisape/Logo_PISAPE-removebg.png",
    "NAVBAR_TITLE": "Pisape",
    "appstatus": "production",
    "DEBUG": false,
    "SHOW_SIDEBAR": true,
    "SHOW_SEARCHBAR": false,
    "SHOW_WALLET_BALANCE": true,
    "SHOW_GUID": false,
    "CHECKONLINE": true,
    "SHOW_APPBAR_GUID": true,
    "SHOW_ALERT": false,
    "SHOW_WALLET_CARD": false,
    "ALLOW_ADD_PARTNER": true,
    "ALLOW_ADD_DISTRIBUTER": true,
   
    "PAGEHOME": "#home",
    "PAGEERROR": "#error",
    "APPKEY": "appkey",
    "REFSITE": "api",
    "URL": "https://app1.pisape.in",
    "ARCHIVE_URL": "https://apiarchive.instantmudra.net",
    "FEEDBACK": "admin@instantmudra.net",
    "SUPPORT": "support@instantmudra.net",
    "SERVER-2": "https://apiarchive2.instantmudra.net/",
    "SERVER-3": "https://apiarchive.instantmudra.net",
    "SERVER1-DATA-DATE-RANGE": {
        "START": "2024-04-01",
        "END": "PRESENT"
    },
    "SERVER2-DATA-DATE-RANGE": {
        "START": "2023-11-01",
        "END": "2024-03-31"
    },
    "SERVER3-DATA-DATE-RANGE": {
        "START": "",
        "END": "2023-10-31"
    },
    "CONFIG": {
        "production": {
            "API_URL": "https://api.instantmudra.net",
            "STORAGE_GATEWAY": "https://storage.instantmudra.net/",
            "S3_BUCKET_KYC": "proddocs-imsecuredocs",
            "S3_BUCKET_DOC": "proddocs-imuserdocs",
            "PING_INTERVAL": 300111,
            "PROCESS_INTERVAL": 60000,
            "NOTIFICATION_INTERVAL": 600211,
            "CACHE_DATA_PERIOD": 300,
            "CACHE_ASSETS_PERIOD": 604800,
            "GREEDY_CACHE": false,
            "CURRENCY": "₹",
            "KEYS": {
                "GOOGLE_ANALYTICS": ""
            },
            "PAN_BASE_URL": "https://pay.instantmudra.net/nsdl/"
        },
        "beta": {
            "API_URL": "https://betaapi.instantmudra.net",
            "STORAGE_GATEWAY": "https://storage.instantmudra.net/",
            "S3_BUCKET_KYC": "proddocs-imsecuredocs",
            "S3_BUCKET_DOC": "proddocs-imuserdocs",
            "PING_INTERVAL": 300111,
            "PROCESS_INTERVAL": 60000,
            "NOTIFICATION_INTERVAL": 600211,
            "CACHE_DATA_PERIOD": 300,
            "CACHE_ASSETS_PERIOD": 604800,
            "GREEDY_CACHE": false,
            "CURRENCY": "₹",
            "KEYS": {
                "GOOGLE_ANALYTICS": ""
            },
            "PAN_BASE_URL": "https://pay.uat.instantmudra.co/nsdl/"
        },
        "development": {
            "API_URL": "https://api.uat.instantmudra.co/",
            "STORAGE_GATEWAY": "https://storage.instantmudra.net/",
            "S3_BUCKET_KYC": "devdocs",
            "S3_BUCKET_DOC": "devdocs",
            "PING_INTERVAL": 300111,
            "PROCESS_INTERVAL": 60000,
            "NOTIFICATION_INTERVAL": 600211,
            "CACHE_DATA_PERIOD": 300,
            "CACHE_ASSETS_PERIOD": 604800,
            "GREEDY_CACHE": false,
            "CURRENCY": "₹",
            "KEYS": {
                "GOOGLE_ANALYTICS": ""
            },
            "PAN_BASE_URL": "https://pay.uat.instantmudra.co/nsdl/"
        }
    },
    "lang": {
        "en-GB": "English"
    },
    "MARKETS": {
        "ANDROID": "com.instantmudra.mapp01",
        "IOS": "",
        "WINDOWS": "",
        "BLACKBERRY": ""
    },
    "LINKS": {
        "REFUND": "https://imwlassets.s3.amazonaws.com/Pisape/Refund%20&%20Cancellation%20Policy%20Pisape.pdf",
        "TERMS": "https://imwlassets.s3.amazonaws.com/Pisape/TERMS_AND_CONDITIONS%20Pisape.pdf",
        "PRIVACY": "https://imwlassets.s3.amazonaws.com/Pisape/PRIVACY%20POLICY%20Pisape.pdf",
        "ABOUT": "https://instantmudra.net/",
    },

    "CONTACT-INFO": {
        "address": "",
        "email": "support@pisape.co.in",
        "logo": ""
    },
    "TOP_UP_REPORTS": ["Direct Top-Up", "CAIN"],
    "LANDING_PAGE_SERVICES": [
       
    ],

    "SIDEBAR_MENUS": [

        {
            id: 126,
            title: "ADMIN",
            icon: <ManageAccountsIcon />,
            selected: false,
            user_role: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
            childrens: [
                {
                    id: 1,
                    title: "REJECTED ACCOUNTS",
                    path: '/rejected_accounts',
                    icon: <GroupsIcon />,
                    user_role: ["partner", "superdistributor","distributor"],
                },
                {
                    id: 2,
                    title: "PENDING ACCOUNTS",
                    path: '/pending_accounts',
                    icon: <GroupsIcon />,
                    user_role: ["partner", "superdistributor", "distributor"],
                },
                {
                    id: 3,
                    title: "ACCOUNTS MANAGEMENT",
                    path: '/account_management',
                    icon: <GroupsIcon />,
                    user_role: ["partner", "distributor", "superdistributor", "subsuperdistributor"],
                },
            ]
        },
        {
            id: 127,
            title: "REPORTS",
            icon: <SummarizeIcon />,
            selected: false,
            user_role: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
            childrens: [

                {
                    id: 1,
                    title: "WALLET STATEMENT",
                    path: '/reports/wallet_statement',
                    icon: <StarIcon />,
                    user_role: ["partner", "retailer", "superdistributor", "subsuperdistributor"],
                },
                {
                    id: 2,
                    title: "TOP UP REPORT",
                    path: '/reports/top_up_report',
                    icon: <StarIcon />,
                    user_role: ["subsuperdistributor", "retailer", "distributor", "partner", "superdistributor"],
                },
                {
                    id: 3,
                    title: "MY TRANSACTIONS",
                    path: '/reports/products',
                    icon: <StarIcon />,
                    user_role: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
                },
                {
                    id: 4,
                    title: "REFUND REPORT",
                    path: '/reports/refund_report',
                    icon: <StarIcon />,
                    user_role: ["retailer", "partner", "distributor", "superdistributor", "subsuperdistributor"]
                },
                {
                    id: 5,
                    title: "COMMISSION REPORT",
                    path: '/reports/commission_report',
                    icon: <StarIcon />,
                    user_role: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
                },
                {
                    id: 6,
                    title: "NETWORK TRANSACTION",
                    path: '/reports/network_transaction',
                    icon: <StarIcon />,
                    user_role: ["partner", "distributor", "superdistributor", "subsuperdistributor"],
                },
                {
                    id: 7,
                    title: "SEARCH TRANSACTION",
                    path: '/reports/search_transaction',
                    icon: <StarIcon />,
                    user_role: [""]
                },
                {
                    id: 8,
                    title: "MPIN REPORT",
                    path: '/reports/mpin_report',
                    icon: <StarIcon />,
                    user_role: ["superdistributor", "retailer", "subsuperdistributor", "distributor", "partner"],
                },
                {
                    id: 9,
                    title: "CHARGES REPORT",
                    path: '/reports/charges_report',
                    icon: <StarIcon variant="btnIcon" />,
                    user_role: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
                },
            ]
        },


    ],

    "ROUTES": [
        {
            id: 24,
            title: "Admin",
            users: ["partner", "superdistributor", "distributor"],
            path: '/pending_accounts',
            element: <PendingAccounts />
        },
        {
            id: 25,
            title: "Admin",
            users: ["partner", "superdistributor", "distributor"],
            path: '/rejected_accounts',
            element: <RejectedAccounts />
        },
        {
            id: 26,
            title: "Reports",
            users: ["retailer"],
            path: '/reports/search_transaction',
            element: <SearchTransaction />
        },
        {
            id: 27,
            title: "Reports",
            users: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
            path: '/reports/top_up_report',
            element: <TopUpReport />
        },
        
    ],

    "REPORT_PAGE_ROUTES": [

        {
            id: 1,
            title: "Wallet Statement",
            path: '/reports/wallet_statement',
            users: ["partner", "distributor", "superdistributor", "subsuperdistributor", "retailer"],

        },
        {
            id: 2,
            title: "Top Up Report",
            path: "/reports/top_up_report",
            users: ["subsuperdistributor", "retailer", "distributor", "partner", "superdistributor"],

        },
        {
            id: 3,
            title: "My Transactions",
            path: '/reports/products',
            users: ["partner", "distributor", "superdistributor", "subsuperdistributor", "retailer"],

        },

        {
            id: 4,
            title: "Refund Report",
            path: '/reports/refund_report',
            users: ["retailer", "partner", "distributor", "superdistributor", "subsuperdistributor"],

        },
        {
            id: 5,
            title: "MPIN Report",
            path: "/reports/mpin_report",
            users: ["partner", "distributor", "superdistributor", "subsuperdistributor", "retailer"],

        },
        {
            id: 6,
            title: "Commission Report",
            path: '/reports/commission_report',
            users: ["partner", "distributor", "superdistributor", "subsuperdistributor", "retailer"],

        },
        {
            id: 7,
            title: "Charges Report",
            path: '/reports/charges_report',
            users: ["partner", "distributor", "superdistributor", "subsuperdistributor", "retailer"],

        },
        {
            id: 8,
            title: "Network Transaction",
            path: '/reports/network_transaction',
            users: ["partner", "distributor", "superdistributor", "subsuperdistributor"],

        },
    ],

    "ANCHOR_MENU": [
        {
            id: 1,
            title: "My Profile",
            onClick: function (navigate) {
                navigate("/profile")
            },
        },
        {
            id: 2,
            title: "Contact Us",
            onClick: function (navigate) {
                navigate("/contact-us")
            },
        },
        {
            id: 3,
            title: "Change Password",
            onClick: function (navigate) {
                navigate("/pwd")
            },
        },
        {
            id: 4,
            title: "Generate MPIN",
            onClick: function (navigate) {
                navigate("/mpinRefund")
            },
        },


        {
            id: 5,
            title: "RD  Download",
            onClick: function (navigate) {
                navigate("/rdDownload")
            },
        },

        {
            id: 6,
            title: "Terms & condition",
            onClick: function () {
                window.open(CONFIG.LINKS.TERMS)
            },
        },
        {
            id: 7,
            title: "Privacy Policy",
            onClick: function () {
                window.open(CONFIG.LINKS.PRIVACY)
            },
        },
        {
            id: 8,
            title: "Refund and Cancellation Policy",
            onClick: function () {
                window.open(CONFIG.LINKS.REFUND)
            },
        },

    ]
}

export default CONFIG

